module.exports = __webpack_public_path__ + "static/index/img/baikal-603.1de27d6d.jpg";